module.exports = __webpack_public_path__ + "static/scale-model-of-sheehan-basquil-park-in-manchester-new-hampshire-dc8a7667d1cde332a7d9ad288cadc710.png";